var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck56 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.807 8.10535C49.0249 8.27488 49.0642 8.58902 48.8947 8.80699L20.8947 44.807C20.8066 44.9202 20.6742 44.9901 20.5311 44.9991C20.3879 45.008 20.2479 44.955 20.1464 44.8536L8.14645 32.8536C7.95118 32.6583 7.95118 32.3417 8.14645 32.1465C8.34171 31.9512 8.65829 31.9512 8.85355 32.1465L20.4531 43.746L48.1053 8.19305C48.2749 7.97508 48.589 7.93581 48.807 8.10535Z",
  fill: "currentColor"
})));
export default SvgCheck56;